/**
 * Anand Tutorials — Parent-facing Key Terms (official 9-clause summary).
 * Displayed on:
 * - /policies/parent (as the prominent top block before the detailed legal text)
 * - /pay-now (as the Fee & Conduct T&C section)
 *
 * Keep this file the single source of truth so both pages stay in sync.
 */

export const PARENT_POLICY_CLAUSES = [
 {
 n: 1,
 title: "Advance Payment Requirement",
 body: "Services will commence only after full/advance payment is received by Anand Tutorials.",
 },
 {
 n: 2,
 title: "Strict Payment Policy (Mandatory)",
 body: "All payments must be made only to Anand Tutorials through official channels. Parents / students are strictly prohibited from making any payment directly to tutors.",
 },
 {
 n: 3,
 title: "Direct Payment Disclaimer (Very Important)",
 body: "If any payment is made directly to a tutor, Anand Tutorials shall not be responsible or liable for:",
 bullets: [
 "Any financial loss",
 "Service discontinuation",
 "Quality of teaching",
 "Any disputes arising from such transactions",
 ],
 footer: "Such payments will be considered unauthorised and outside the responsibility of Anand Tutorials.",
 },
 {
 n: 4,
 title: "No Bypass Policy",
 body: "Parents / students are strictly prohibited from engaging tutors privately or continuing classes outside Anand Tutorials. Any attempt to bypass the platform will result in immediate termination of services without notice.",
 },
 {
 n: 5,
 title: "Communication & Scheduling",
 body: "All class scheduling, rescheduling, and communication must be done through Anand Tutorials. Direct arrangements with tutors are not permitted.",
 },
 {
 n: 6,
 title: "Tutor Replacement Policy",
 body: "If dissatisfied, parents must inform Anand Tutorials. We will make reasonable efforts to resolve the issue or provide a replacement tutor.",
 },
 {
 n: 7,
 title: "Refund Policy",
 body: "Fees once paid are non-refundable, except under conditions approved by Anand Tutorials management.",
 },
 {
 n: 8,
 title: "Termination Rights",
 body: "Anand Tutorials reserves the right to suspend or terminate services in case of policy violation or non-compliance.",
 },
 {
 n: 9,
 title: "Acceptance of Terms",
 body: "By enrolling, the parent / student agrees to comply with all policies of Anand Tutorials.",
 },
];

export const PARENT_POLICY_SUPPORT = {
 phones: ["our Customer Care team", "our Jabalpur Head Office team"],
 email: "anandhometutorials@gmail.com",
};
